/**
 * Hide option values whose variant does not exist (replaces the Camouflage Hide Variants app).
 *
 * "Does not exist" is not "sold out": a sold-out variant stays visible so the restock note and
 * the Back in Stock form still work. Only combinations with no variant at all are hidden, e.g.
 * Copper on any size but 6". The first option (Size) is never filtered, so every size stays
 * reachable; each later option is filtered by the values selected before it.
 *
 * variantComboExists() is pure so it can be unit-tested. The rest reads the data island that
 * sections/main-product.liquid renders and re-applies after Dawn swaps the picker's HTML.
 */
function variantComboExists(combos, selected, position, value) {
  return combos.some((combo) => {
    if (combo[position] !== value) return false;
    for (let i = 0; i < position; i++) {
      if (combo[i] !== selected[i]) return false;
    }
    return true;
  });
}

window.variantComboExists = variantComboExists;

(function () {
  const MISSING = 'variant-combo-missing';

  function fieldsets(picker) {
    return Array.from(picker.querySelectorAll('fieldset'));
  }

  function apply(picker) {
    const island = document.querySelector(`[data-variant-combos="${picker.dataset.section}"]`);
    if (!island) return;
    const combos = JSON.parse(island.textContent);
    const groups = fieldsets(picker);
    // Positions only line up when every option renders as a radio fieldset (pills or swatches).
    if (!combos.length || groups.length !== combos[0].length) return;
    const selected = groups.map((fs) => fs.querySelector('input:checked')?.value);

    for (let position = 1; position < groups.length; position++) {
      const inputs = Array.from(groups[position].querySelectorAll('input[type="radio"]'));
      inputs.forEach((input) => {
        input.classList.toggle(MISSING, !variantComboExists(combos, selected, position, input.value));
      });

      // The chosen value has no variant under the new upstream selection: move to the first one
      // that does, the same way a shopper would. Dawn handles the click and re-renders; stop here
      // and let the observer re-apply against the new markup.
      const checked = inputs.find((input) => input.checked);
      if (checked && checked.classList.contains(MISSING)) {
        const fallback = inputs.find((input) => !input.classList.contains(MISSING));
        if (fallback) {
          fallback.click();
          return;
        }
      }
    }
  }

  function applyAll() {
    document.querySelectorAll('variant-selects').forEach(apply);
  }

  function start() {
    applyAll();
    // Dawn replaces the picker's innerHTML after every option change (and quick-add injects a
    // whole product section), so re-apply whenever the DOM under <body> changes pickers.
    new MutationObserver((mutations) => {
      const touchesPicker = mutations.some(
        (m) =>
          m.target.closest?.('variant-selects') ||
          Array.from(m.addedNodes).some((n) => n.nodeType === 1 && (n.matches('variant-selects') || n.querySelector('variant-selects')))
      );
      if (touchesPicker) applyAll();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
